import { render, staticRenderFns } from "./Farmers.vue?vue&type=template&id=1b5cd06a&"
import script from "./Farmers.vue?vue&type=script&lang=js&"
export * from "./Farmers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports